import React from "react";
import { useTranslation } from "react-i18next";
const DeliveryDialogHeader = ({ isEstimatedDate }) => {
  const { t } = useTranslation("common");

  return (
    <h2 className="f23 sBold text-brightGrey mb-4">
      {isEstimatedDate ? t("Estimated delivery on") : t("Delivery on")}
    </h2>
  );
};

export default DeliveryDialogHeader;
